var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.159,
    height: 36.159,
    viewBox: "0 0 36.159 36.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17088",
    "data-name": "Path 17088",
    d: "M0,0H36.159V36.159H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17089",
    "data-name": "Path 17089",
    d: "M21.361,11.986V26.962H9.462V11.986h11.9M19.13,3H11.693L10.206,4.5H5v3H25.824v-3H20.618Zm5.206,5.991H6.487V26.962a2.994,2.994,0,0,0,2.975,3h11.9a2.994,2.994,0,0,0,2.975-3Z",
    transform: "translate(2.667 1.6)",
    fill: "#d81f1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.31c9ef88d6b940bf59fe912e109b9e65.svg";
export { ForwardRef as ReactComponent };